// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".burger-button[data-v-25f0c11c]{height:30px;background:none;border:1px solid #cfd8dc;color:rgba(0,0,0,.87);font-size:14px;font-weight:500;outline:none;letter-spacing:.5px;padding:5px 7px;text-transform:uppercase;width:59px}.burger-button--active[data-v-25f0c11c]{border:none;font-size:28px;padding:0;text-align:right}.burger-button--active .wficon-clear[data-v-25f0c11c]{display:flex;justify-content:flex-end}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
